import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';
import {
  AdminService,
  ShareholderEditSectionData,
  ShareholderEditSection_
} from '@appShared/services/admin.service';
import { CommonService } from '@appShared/services/common.service';
import { ButtonComponent } from '@appShared/components/button/button.component';
import { ModalComponent } from '@appShared/components/modal/modal.component';
import { AutofocusDirective } from '@appShared/directives/auto-focus.directive';
import { IShareholder } from '@appShared/interfaces/[Model-based]/shareholder.interface';
import { IEmployeeSearchResult } from '@appShared/interfaces/[Interface-based]/employee-search-result.interface';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-shareholder-pin-modal',
   templateUrl: './shareholder-pin-modal.component.html',
   imports: [
      ReactiveFormsModule,
      NgxMaskDirective,
      AutofocusDirective,
      ModalComponent,
      ButtonComponent
   ]
})
export class ShareholderPinModalComponent implements OnInit {
  @Input() employee: IEmployeeSearchResult;
  @Input() shareholderSectionUpdated: (shareholder: IShareholder) => void;

  /* form/form-fields */
  pinForm: FormGroup;
  pin: FormControl;
  mouseoverCreateShareholder: boolean;
  isSubmitting: boolean;

  constructor(
    private _adminService: AdminService,
    private _commonService: CommonService,
    private _activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.pin = new FormControl(null, [
      Validators.minLength(4),
      Validators.maxLength(4),
      Validators.required
    ]);

    this.pinForm = new FormGroup({
      pin: this.pin
    });
  }

  createShareholder(): void {
    this.isSubmitting = true;

    const shareholderFormValues = this.pinForm.value;
    const pin = shareholderFormValues.pin;

    const displayName = this.employee.displayName;
    let firstName = this.employee.firstName || '';
    let lastName = this.employee.lastName || '';

    /* attempt to resolve first/last from displayname if missing */
    if (!firstName && !lastName && displayName) {
      let splitName = [];

      /*display is last,first - split on comma */
      if (displayName.includes(',')) {
        splitName = displayName.split(',');
        firstName = splitName[1] || '';
        lastName = splitName[0] || '';
      } else {
        splitName = displayName.split(' ');
        firstName = splitName[0] || '';
        lastName = splitName[1] || '';
      }
    }

    const newShareholder = {
      firstName,
      lastName,
      pin,
      userObjectIdentifier: this.employee.objectId
    } as IShareholder;

    this._adminService
      .createUpdateShareholder(newShareholder)
      .then(shareholder => {
        this._commonService.messageUser('Shareholder created!');

        this.shareholderSectionUpdated(shareholder);

        this._activeModal.close();
      })
      .catch(() => {
        /* Do Nothing */
      })
      .finally(() => setTimeout(() => (this.isSubmitting = false), 500));
  }
}
